import { render, staticRenderFns } from "./Intolerancias.vue?vue&type=template&id=ea946984&"
import script from "./Intolerancias.vue?vue&type=script&lang=js&"
export * from "./Intolerancias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports